// extracted by mini-css-extract-plugin
module.exports = {"root":"TripCartContentFooter_root__OGKj_","content":"TripCartContentFooter_content___w_DT"};